<template>
    <div :class="activeClasses">
        <div class="user-activity__list">
            <b-card
                v-if="!isAlone"
                bg-variant="dark"
                text-variant="white"
                no-body
                class="user-activity__popup"
            >
                <b-icon-exclamation-circle font-scale="2"></b-icon-exclamation-circle>
                <span>Flera användare är nu aktiva på denna sida.</span>
            </b-card>
            <div
                v-for="(user, u_index) in usersList"
                :key="'u-' + u_index"
            >
                <b-avatar
                    :style="{background: user.color}"
                    :text="user.short"
                    size="sm" v-b-tooltip.hover="user.name"
                ></b-avatar>
            </div>
        </div>
        <b-badge :variant="statusColor"
                 pill size="lg">
            <b-icon-people></b-icon-people>
            {{ this.usersList.length }}
        </b-badge>
    </div>
</template>
<script>
import axios from 'axios';
import { BIconPeople } from 'bootstrap-vue';
import { stringToColour } from '@services/Helpers';
import { mapState } from 'pinia';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    name: 'ActivityNotification',
    components: {
        BIconPeople,
    },
    props: {
        channel: {
            type: String,
            default: '',
        },
        fixed: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            polling: null,
            usersList: [],
            isAlone: true,
        };
    },
    mounted() {
        let interval = 3000;
        if (process.env.MIX_ACTIVITY_POLLING_INTERVAL !== undefined) {
            interval = process.env.MIX_ACTIVITY_POLLING_INTERVAL;
        }
        if (interval > 0) {
            this.checkIn();
            this.polling = setInterval(() => {
                this.checkIn();
            },
            interval);
        }
    },
    beforeDestroy() {
        clearInterval(this.polling);
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        computedList() {
            return this.usersList.map((item) => item.name + '</br>').join('');
        },
        activeClasses() {
            const classes = ['user-activity'];

            if (this.fixed) {
                classes.push('user-activity--fixed');
            }

            if (!this.isAlone) {
                classes.push('user-activity--not-alone');
            }

            return classes.join(' ');
        },
        statusColor() {
            if (this.isAlone) {
                return 'success';
            }

            return 'danger';
        },
    },
    methods: {
        checkIn() {
            axios.post('/vue/users/activity', {
                channel: this.channel,
                user_id: this.user.id,
                name: this.user.name,
            }, { withCredentials: true }).then((res) => {
                if (res.status === 200) {
                    this.usersList = Object.entries(res.data).map(([key, value]) => ({
                        id: key,
                        name: value,
                        short: value.match(/\b(\w)/g).join('').toUpperCase(),
                        color: stringToColour(value),
                    }));
                    this.isAlone = this.usersList.every((item) => parseInt(item.id, 10) === parseInt(this.user.id, 10));
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.user-activity {
    display: grid;
    grid-template-columns: min-content 1fr;
    gap: 8px;

    &--fixed {
        position: fixed;
        z-index: 500;
        right: 2rem;
        bottom: 1rem;
    }

    &__list {
        display: flex;
        gap: 2px;
    }

    &__popup {
        display: grid;
        grid-template-columns: 48px 1fr;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        position: absolute;
        width: 250px;
        right: 0;
        top: -16px;
        transform: translateY(-100%);
    }

    .b-avatar {
        &:hover:after {
            position: relative;
            display: block;
            content: attr(title);
            top: 0;
        }
    }
}
</style>
